import React from 'react';
import Button from "../button";
import FormGroupSelectInput from "../formGroupSelectInput";
import '../../style/articlesList.css'
import '../../style/dots.css';
import Autosuggest from "react-autosuggest";
import ArticleDeleteModal from "./articleDeleteModal";
import moment from "moment";
import {Link} from "react-router-dom";
import {TABLE_VIEW_OPTIONS} from "../../helpers/variables";
import CustomTable from "../General/customTable/CustomTable";

const columns = [
	{propertyName: "title", header: "Title", formatter: (row) => (
			<Link to={'/articles/edit-article/' + row.id}>{row.title}</Link>
		)},
	{propertyName: "authorName", header: "Author"},
	{
		propertyName: "createdAt",
		header: "Creation Date",
		formatter: (datum) => moment(datum.createdAt).format("DD/MM/YYYY")},
	{propertyName: "live", header: "Status", formatter: (datum) => (
			[
				<svg
					xmlns="http://www.w3.org/2000/svg"
					key={0}
					style={datum.live ? {fill: '#94b494'} : {fill: '#e0666c'}} width={'12px'}
					height={'12px'} viewBox="0 0 12 12"><title>Asset 4</title>
					<g id="Layer_2" data-name="Layer 2">
						<g id="info">
							<circle className="cls-1" cx="6" cy="6" r="6"/>
						</g>
					</g>
				</svg>,
				datum.live ? ' Published' : ' Unpublished'
			]
		)},
];

const ArticlesList = (props) => {
	return (
		<div className="row form-group">
			<div className="col-sm-12">
				{
					props.articlesList.deleteModal ?
						<div className="solicitorGroupList-modal">
							<div className="appFormRefSettings-modal-content">
								<div className="appFormRefSettings-close-button" onClick={()=>props.changeArticlesListSettings('deleteModal',false)}></div>
								<ArticleDeleteModal
									deleting={props.articlesList.deleting}
									handleDelete={props.handleDelete}
									changeArticlesListSettings={props.changeArticlesListSettings}
									findArticles={props.findArticles}
								/>
							</div>
						</div>
						:
						null
				}
				<div className="row">
					<div className="col-sm-12">
						<h2 className="header2Style">Articles</h2>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-12">
						<p className="generalText">
							{props.articlesList.infoMessage}
						</p>
					</div>
				</div>
				<div className="row form-group">
					<div className="col-sm-12">
						<Button
							clickHandler={() => props.push('/articles/add-article')}
							wrapper="btn-wrapper"
							btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
							label="Create New Article"/>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-12">
						<form
							onSubmit={evt => {
								evt.preventDefault();
								props.changeArticlesListSettings('selectedSuggestions', props.articlesList.suggestions)
							}}
							className="form-horizontal">
							<FormGroupSelectInput
								Value={props.articlesList.selectedStatus}
								Label='Status'
								LeftWrapper="col-sm-2"
								Name={'selectedStatus'}
								Options={[{key: '', value: 'All Statuses'}, {
									key: 'published',
									value: 'published'
								}, {key: 'unpublished', value: 'unpublished'}]}
								HandleInputChange={(evt) => props.changeArticlesListSettings(evt.target.name, evt.target.value)}
								CenterWrapper="col-sm-6 formGroupSelectInput-select-wrapper"
								RightWrapper=""
								SelectStyle={'form-control formGroupSelectInput-select'}
							/>
							<div className="row">
								<div className="col-sm-2">
									<label className={'control-label.text-left formGroupSelectInput-label'}>
										{"Search"}
									</label>
								</div>
								<div className="col-sm-6"
										 onKeyPress={(evt) => evt.key === 'Enter' ? props.handleAutoSuggestButton() : null}
								>
									<Autosuggest
										suggestions={props.suggestions}
										onSuggestionsFetchRequested={props.onSuggestionsFetchRequested}
										onSuggestionsClearRequested={props.onSuggestionsClearRequested}
										getSuggestionValue={props.getSuggestionValue}
										renderSuggestion={props.renderSuggestion}
										inputProps={props.inputProps}
										onSuggestionSelected={props.onSuggestionSelected}
										theme={{
                                            container: 'agents-list-action-autoSuggest-container',
											input: 'applicationsAndPolicies-autosuggest',
											suggestionsContainer: 'applicationsAndPolicies-autosuggest-suggestionsContainer',
											suggestionsList: 'applicationsAndPolicies-autosuggest-suggestionsList',
											suggestion: 'applicationsAndPolicies-autosuggest-suggestion',
											suggestionHighlighted: 'applicationsAndPolicies-autosuggest-suggestion-highLighted'
										}}
									/>
									<div className="applicationsAndPolicies-autosuggest-search-icon"
											 onClick={props.handleAutoSuggestButton}>
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>Asset 6</title>
											<g id="Layer_2" data-name="Layer 2">
												<g id="info">
													<path
														d="M15.61,13.72l-3.48-3.48-.06,0a6.58,6.58,0,1,0-1.88,1.88l0,.06,3.48,3.48a1.34,1.34,0,0,0,1.89-1.89Zm-9-2.84a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,6.58,10.88Z"/>
												</g>
											</g>
										</svg>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-12">
						{
							props.articlesList.articles.length > 0?
								<div>
									<CustomTable
										onReorderRow={(rows) => {
											props.changeArticlesListSettings('articles', rows)
										}}
										onReorder={props.onReorder}
										isReorderable
										onSelectedActionApply={props.handleEdit}
										onSelectAction={(evt) => props.changeArticlesListSettings(evt.target.name, evt.target.value)}
										selectedAction={props.articlesList.selectedAction}
										selectActions={[
											{key: 'publish', label: 'Publish'},
											{key: 'unpublish', label: 'Unpublish'},
											{key: 'delete', label: 'Delete'},
										]}
										onSelectAll={props.checkAll}
										onDatumSelect={props.handleArticleCheckAndUnCheck}
										selected={props.articlesList.selectedArticles}
										selectable
										accordionItemHeaderFormatter={(row) => (
											`Title: ${row.title} Author: ${row.authorName}`
										)}
										onPageSizeChange={(evt) => props.changeArticlesListSettings(evt.target.name, evt.target.value)}
										goAtPage={props.changeArticlesListSettings}
										onPageShift={props.pageShift}
										loading={props.articlesList.fetching}
										responsive
										striped
										columns={columns}
										data={props.articlesList.articles}
										pageSize={parseInt(props.articlesList.selectedView)}
										totalRecords={props.articlesList.totalRecords}
										totalPages={parseInt(props.articlesList.totalBoxes)}
										page={props.articlesList.page}
										pageSizeOptions={TABLE_VIEW_OPTIONS}
									/>
								</div>
								:
								<div className="text-center">
									<span>No article to show.</span>
								</div>
						}
					</div>
				</div>
			</div>
		</div>
	)
};

export default ArticlesList;